import axios from 'axios'
import util from 'vue-utear'
import { instance } from '@/assets/js/keycloak'
/* global  BUILD_ENV */

export const host = {
  local: '//192.168.220.140:8080',
  // local: '//dev-op-api.apuscn.com/argus-alarm',
  dev: '//dev-op-api.apuscn.com/argus-alarm',
  test: '//test-op-api.apuscn.com/argus-alarm',
  qa: '//test-op-api.apuscn.com/argus-alarm',
  prod: '//op-api.apuscn.com/argus-alarm',
  ali: '//ali-op-api.apuscn.com/argus-alarm',
  'ali-dev': 'http://dev-ali-argus-api.apuscn.com',
  zz: 'http://zz-argus-api.apuscn.com'
}[BUILD_ENV]

var thisAxios = axios.create({
  baseURL: host,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }
  // withCredentials: true,
  // crossDomain: true
})

// request interceptors
thisAxios.interceptors.request.use((config) => {
  config.headers.authorization = 'Bearer ' + instance.token
  return config
})

export default thisAxios

export const getPermission = () => {
  let url = 'https://op-api.apuscn.com'
  if (['local', 'dev', 'test', 'qa'].includes(BUILD_ENV)) {
    url = 'https://test-op-api.apuscn.com'
  }
  const key = BUILD_ENV === 'ali' ? 'argus-ali' : 'argus'
  const params = { system_key: key }
  return thisAxios.post(url + '/permission-service/api/web/permission/obtain', params, {
    withCredentials: false
  }).then(({ data }) => {
    if (+data.code === 1) {
      return data.data || []
    } else {
      throw data.message
    }
  }).catch((err = '') => {
    util.Message.error(err)
    return []
  })
}
